import { ReactNode } from 'react'

export function Container({ children, className = '' }: { children: ReactNode; className?: string }) {
  return <div className={`mx-auto w-full max-w-8xl px-6 lg:px-10 ${className}`}>{children}</div>
}
